import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocReportsTeamRedirectRoute: InvariantJiraRoute = {
	name: 'eoc-reports',
	path: '/jira/ops/teams/:teamId/reports',
	exact: true,
};
